import { Box, Grid, Typography } from '@mui/material'

import React from 'react'
import PinkButton from '../../components/customButtons/PinkButton'

export default function NewPage400() {
  return (
    <>
      <Box

     
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100%"
        px={{ sm: 2, xs: 2 }}
      >
        <Box width={400}>
          <img src="/newdashboard/ErrorPageIcons/Website_Error.png" />
        </Box>

        <Typography
          mt={3}
          color="#000000"
          fontFamily="Inter"
          fontSize="26px"
          letterSpacing="1px"
          lineHeight="100%"
          style={{ fontWeight: 700 }}
        >
          Bad Request
        </Typography>

        <Typography
          color="#000000"
          fontFamily="Inter"
          fontSize="20px"
          mt={2}
          letterSpacing="0px"
          textAlign="center"
          style={{ fontWeight: 400 }}
        >
          {" "}
          Invalid request. Please check your input and try again.
        </Typography>

        <Typography mt={3}>
          <PinkButton
            buttonTitle="Retry"
            startIcon={<img src="/newdashboard/ErrorPageIcons/fa_repeat.png" />}
          />
        </Typography>
      </Box>
    </>
  )
}
